module.exports = __webpack_public_path__ + "static/media/32a Turtle.70559e4e.jpg";